import { render } from "./MediaEmbed.vue?vue&type=template&id=8a76f21c&lang=pug"
import script from "./MediaEmbed.vue?vue&type=script&lang=js"
export * from "./MediaEmbed.vue?vue&type=script&lang=js"

import "./MediaEmbed.vue?vue&type=style&index=0&id=8a76f21c&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__